/**
 * Points and Top Agents Components
 */
import { Award, Trophy } from "lucide-react";

// Points Card - Desktop
export const PointsCardDesktop = ({ scores, loading }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden sticky top-24" data-testid="my-points-card">
    <div className="bg-gradient-to-br from-[#1B3F8F] to-[#2a5fc9] p-5 text-white">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-14 h-14 rounded-xl bg-white/20 flex items-center justify-center">
          <Award size={28} />
        </div>
        <div>
          <p className="text-blue-100 text-sm">Moji bodovi</p>
          <p className="text-3xl font-bold" data-testid="points-month">
            {loading ? "…" : scores.month}
          </p>
        </div>
      </div>
      <p className="text-blue-200 text-sm">Ovaj mjesec</p>
    </div>
    <div className="p-5">
      <div className="flex items-center justify-between py-3 border-b border-gray-100">
        <span className="text-sm text-gray-500">Danas</span>
        <span className="text-lg font-semibold text-gray-900" data-testid="points-today">
          {loading ? "…" : scores.today}
        </span>
      </div>
      <div className="flex items-center justify-between py-3">
        <span className="text-sm text-gray-500">Ovaj mjesec</span>
        <span className="text-lg font-semibold text-gray-900">
          {loading ? "…" : scores.month}
        </span>
      </div>
    </div>
  </div>
);

// Points Card - Mobile
export const PointsCardMobile = ({ scores, loading }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 mb-4" data-testid="my-points-card-mobile">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">Moji bodovi</p>
        <div className="space-y-1">
          <p className="text-sm text-gray-700">
            Danas: <span className="font-semibold text-gray-900" data-testid="points-today-mobile">
              {loading ? "…" : scores.today}
            </span>
          </p>
          <p className="text-sm text-gray-700">
            Ovaj mjesec: <span className="font-semibold text-gray-900" data-testid="points-month-mobile">
              {loading ? "…" : scores.month}
            </span>
          </p>
        </div>
      </div>
      <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center">
        <Award size={24} className="text-amber-500" />
      </div>
    </div>
  </div>
);

// Top 3 Agents Card
export const TopAgentsCard = ({ agents, loading }) => {
  const rankConfig = [
    { bg: "bg-gradient-to-r from-amber-400 to-yellow-500", icon: "text-amber-600", medal: "🥇" },
    { bg: "bg-gradient-to-r from-gray-300 to-gray-400", icon: "text-gray-500", medal: "🥈" },
    { bg: "bg-gradient-to-r from-amber-600 to-orange-500", icon: "text-amber-700", medal: "🥉" }
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 mb-4 animate-fadeIn" data-testid="top-agents-card">
      <div className="flex items-center gap-2 mb-3">
        <Trophy size={18} className="text-amber-500" />
        <h3 className="text-sm font-medium text-gray-700">Top 3 agenta ovaj mjesec</h3>
      </div>
      
      {loading ? (
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-10 bg-gray-100 rounded-lg animate-pulse" />
          ))}
        </div>
      ) : agents.length === 0 ? (
        <p className="text-sm text-gray-500 text-center py-4">Nema podataka za ovaj mjesec</p>
      ) : (
        <div className="space-y-2">
          {agents.map((agent, index) => (
            <div
              key={agent.user_id}
              className={`flex items-center gap-3 p-2.5 rounded-lg ${index === 0 ? 'bg-amber-50 border border-amber-100' : 'bg-gray-50'}`}
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold ${rankConfig[index]?.bg || 'bg-gray-400'}`}>
                {agent.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium truncate ${index === 0 ? 'text-amber-900' : 'text-gray-900'}`}>
                  {agent.name}
                </p>
              </div>
              <div className="flex items-center gap-1">
                <span className={`text-sm font-bold ${index === 0 ? 'text-amber-600' : 'text-gray-600'}`}>
                  {agent.points}
                </span>
                <span className="text-xs text-gray-400">bod.</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
